import { useMemo, useCallback } from 'react'
import { MonitoringHook } from '../types'

/**
 * useNoOpMonitoring
 *
 * Hook for no-op monitoring (on-premises deployments).
 * All monitoring calls are silently ignored (no external services called).
 */
export default function useNoOpMonitoring(): MonitoringHook {
  const addAction = useCallback(() => {
    // No-op: monitoring disabled for on-prem
  }, [])

  const logError = useCallback(() => {
    // No-op: monitoring disabled for on-prem
  }, [])

  const setUser = useCallback(() => {
    // No-op: monitoring disabled for on-prem
  }, [])

  const setUserProperty = useCallback(() => {
    // No-op: monitoring disabled for on-prem
  }, [])

  return useMemo(
    () => ({
      addAction,
      logError,
      setUser,
      setUserProperty,
    }),
    [addAction, logError, setUser, setUserProperty]
  )
}
